import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import RailwayWindowGlassBanner from "../../../Assets/Product_Images/RailwayWindowGlass/RailwayWindowGlassBanner.jpg";
import RailwayWindowGlass1 from "../../../Assets/Product_Images/RailwayWindowGlass/RailwayWindowGlass1.jpg";
import RailwayWindowGlass2 from "../../../Assets/Product_Images/RailwayWindowGlass/RailwayWindowGlass2.webp";
import RailwayWindowGlass3 from "../../../Assets/Product_Images/RailwayWindowGlass/RailwayWindowGlass3.jpg";
import { Link } from "react-router-dom";

const Railway_Window_Glass = () => {
  return (
    <div>
      <Header />
      {/* banner section start  */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${RailwayWindowGlassBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h2>
                  <Link
                    to="/AboutUs"
                    className="text-decoration-none text-white"
                  >
                    ABOUT US
                  </Link>{" "}
                  / <span className="text-white">Railway Window Glass</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end */}

      {/* about tabbing section start  */}
      <section className="container-fluid about_Products_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="blog_text wow fadeInUp">
                <h5
                  style={{
                    color: "#153fa4",
                    fontFamily: "Segoe UI, sans-serif",
                    fontSize: "40px",
                    fontWeight: "700",
                    marginBottom: "15px",
                  }}
                >
                  {" "}
                  Railway Window Glass
                </h5>
                <p>
                  Developed with a particular emphasis on strength, safety, and
                  comfort, railway window glass The glass must endure fast
                  temperature variations, high wind pressure, and debris impacts
                  because of the speed and surroundings trains operate in.
                  Common materials for safety and insulation are laminated and
                  double-glazed glasses.
                </p>
                <p>
                  MSince it holds together even when broken, laminated glass
                  aids in reducing accident injuries. Double-glazed units
                  guarantee a calm and pleasant ride for travelers by providing
                  thermal and acoustic insulation. Some trains employ smart
                  glass technology that can be tinted or electronically changed
                  for glare and privacy control.
                </p>
                <p>
                  Railway window glass is also treated with UV filters and
                  scratch-resistant coatings. Designed for long periods of use,
                  it preserves optical clarity under frequent washing and
                  weather exposure. This glass also helps to improve the design
                  and energy economy of contemporary train carriages.
                </p>

                <p>
                  <strong>Key Features:</strong>
                </p>
                <ul>
                  <li>Break and crack resistance</li>
                  <li>High durability under stress</li>
                  <li>Smooth, optimum finish</li>
                </ul>
              </div>
              <div className="Products_img gap-5 mt-5 wow fadeInUp">
                <img src={RailwayWindowGlass1} style={{width : "250px" , height : "250px"}} alt="Bus" />
                <img src={RailwayWindowGlass2} style={{width : "250px" , height : "250px"}} alt="car" />
                <img src={RailwayWindowGlass3} style={{width : "250px" , height : "250px"}} alt="car" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about tabbing section End */}

      <Footer />
    </div>
  );
};

export default Railway_Window_Glass;
